module.exports = __webpack_public_path__ + "img/4c.5e9badcb.svg";